<template>
  <div>
    <h1 class="page-header">{{ $t('transportationdistance.distance') }}</h1>
    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="form-group m-b-15">
              <label>{{
                $t('transportationdistance.distanceFrom')
              }}</label>
              <input
                v-model.number="model.distance_from"
                type="number"
                class="form-control"
                :class="{ 'is-invalid': errors.has('distance_from') }"
                :placeholder="$t('transportationdistance.enterthestartpoint')"
              />
              <div class="invalid-feedback" v-if="errors.has('distance_from')">
                {{ errors.first('distance_from') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label>{{
                $t('transportationdistance.distanceTo')
              }}</label>
              <input
                v-model.number="model.distance_to"
                type="number"
                class="form-control"
                :class="{ 'is-invalid': errors.has('distance_to') }"
                :placeholder="$t('transportationdistance.enterthestartpoint')"
              />
              <div class="invalid-feedback" v-if="errors.has('distance_to')">
                {{ errors.first('distance_to') }}
              </div>
            </div>
            <div class="form-group">
              <label class="required">{{ $t('transportationdistance.description') }}</label>
              <textarea
                v-model="model.distance_description"
                class="form-control"
                :class="{ 'is-invalid': errors.has('distance_description') }"
                :placeholder="$t('transportationdistance.description')"
              ></textarea>
              <div
                class="invalid-feedback"
                v-if="errors.has('distance_description')"
              >
                {{ errors.first('distance_description') }}
              </div>
            </div>
            <div class="text-right">
              <ts-button v-if="updating" class="mr-2" @click.prevent="cancel">
                {{ $t('cancel') }}
              </ts-button>
              <ts-button
                v-if="updating"
                class="btn-primary"
                :waiting="waiting"
                @click.prevent="update"
              >
                {{ $t('update') }}
              </ts-button>
              <ts-button
                v-if="!updating"
                :waiting="waiting"
                class="btn-primary"
                @click.prevent="store"
                >{{ $t('save') }}</ts-button
              >
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-9 col-sm-12">
        <data-table :fetch="fetch" @fetched="fetch = false"></data-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DataTable from './table'
import { Errors } from 'form-backend-validation'

export default {
  name: 'transportation-distance-form',
  components: {
    DataTable
  },
  data() {
    return {
      model: {
        distance_id: '',
        distance_from: '',
        distance_to: '',
        distance_description: ''
      },
      errors: new Errors(),
      waiting: false,
      fetch: false,
      updating: false
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('transportationDistance', ['edit_data'])
  },
  methods: {
    store() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('transportationDistance/store', this.model)
        .then(response => {
          this.clearInput()
          this.$toasted.success(response.message)
          this.waiting = false
          this.fetch = true
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },
    update() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('transportationDistance/update', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.waiting = false
          this.fetch = true
          this.cancel()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },

    cancel() {
      this.updating = false
      this.$store.commit('transportationDistance/SET_EDIT_DATA', {})
      this.$router.push({ name: 'transportation-distance' })
      this.clearInput()
    },
    clickBackURL() {
      this.$store.commit('transportationDistance/SET_EDIT_DATA', {})
      this.clearInput()
      this.fetch = true
      this.updating = false
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.errors = new Errors()
        this.model = _.clone(this.edit_data)
        this.updating = true
      }
    },
    clearInput() {
      this.model = {
        distance_id: '',
        distance_from: '',
        distance_to: '',
        distance_description: ''
      }
    }
  },
  watch: {
    edit_data: {
      handler() {
        this.setEditData()
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('transportationDistance/RESET_STATE')
      this.clickBackURL()
    }
    next()
  }
}
</script>
